export const PDF_LAYOUT_STEP = 5;
export const PDF_SIZE_STEP = 10;

export const DEFAULT_PDF_LAYOUT = {
  logo: { x: 0, y: 0, w: 0, h: 0 },
  meta: { x: 0, y: 0, w: 0, h: 0 },
  styleSheet: { x: 0, y: 0, w: 0, h: 0 },
  details: { x: 0, y: 0, w: 0, h: 0 },
  productDescription: { x: 0, y: 0, w: 0, h: 0 },
  pricingTable: { x: 0, y: 0, w: 0, h: 0 },
  shippingTable: { x: 0, y: 0, w: 0, h: 0 },
  customTables: { x: 0, y: 0, w: 0, h: 0 },
};

export function normalizePdfLayout(raw) {
  const base = JSON.parse(JSON.stringify(DEFAULT_PDF_LAYOUT));
  if (!raw || typeof raw !== 'object') return base;
  Object.keys(base).forEach((key) => {
    const section = raw[key];
    base[key] = {
      x: Number(section?.x) || 0,
      y: Number(section?.y) || 0,
      w: Number(section?.w) || 0,
      h: Number(section?.h) || 0,
    };
  });
  return base;
}

export function getSectionOffset(quoteData, section) {
  const layout = normalizePdfLayout(quoteData?.pdfLayout);
  return layout[section] || { x: 0, y: 0, w: 0, h: 0 };
}

export function nudgePdfLayout(layout, section, dx, dy) {
  const normalized = normalizePdfLayout(layout);
  const current = normalized[section] || { x: 0, y: 0, w: 0, h: 0 };
  return {
    ...normalized,
    [section]: {
      ...current,
      x: current.x + dx,
      y: current.y + dy,
    },
  };
}

export function resizePdfLayoutSection(layout, section, dw, dh) {
  const normalized = normalizePdfLayout(layout);
  const current = normalized[section] || { x: 0, y: 0, w: 0, h: 0 };
  return {
    ...normalized,
    [section]: {
      ...current,
      w: current.w + dw,
      h: current.h + dh,
    },
  };
}

export function resetPdfLayoutSection(layout, section) {
  const normalized = normalizePdfLayout(layout);
  return {
    ...normalized,
    [section]: { x: 0, y: 0, w: 0, h: 0 },
  };
}

/** Scale autotable column widths from layout w offset. */
export function scaleColumnStyles(columnStyles, wOffset = 0) {
  if (!wOffset || !columnStyles) return columnStyles;
  const scale = 1 + wOffset / 300;
  const scaled = {};
  Object.entries(columnStyles).forEach(([key, style]) => {
    scaled[key] = {
      ...style,
      cellWidth: style.cellWidth != null
        ? Math.max(18, Math.round(style.cellWidth * scale))
        : style.cellWidth,
    };
  });
  return scaled;
}

/** Derive font size and cell padding from layout h offset. */
export function tableStyleFromOffset(offset, base = { fontSize: 8, cellPadding: 4 }) {
  const h = offset?.h || 0;
  return {
    fontSize: Math.max(6, base.fontSize + Math.floor(h / 20)),
    cellPadding: Math.max(2, base.cellPadding + Math.floor(h / 15)),
  };
}

export function tableMarginsFromLayout(margin, pageWidth, contentRight, offset) {
  return {
    left: margin + (offset?.x || 0),
    right: Math.max(20, pageWidth - contentRight - (offset?.x || 0)),
  };
}

export function normalizeTableLayout(raw) {
  if (!raw || typeof raw !== 'object') {
    return { x: 0, y: 0, w: 0, h: 0 };
  }
  return {
    x: Number(raw.x) || 0,
    y: Number(raw.y) || 0,
    w: Number(raw.w) || 0,
    h: Number(raw.h) || 0,
  };
}
